"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgEmptyChart = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ stroke: "currentColor", fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("rect", { x: 0.1875, y: 0.1875, width: 23.625, height: 23.625, rx: 1.3125, fill: "currentColor", fillOpacity: 0.11, strokeWidth: 0.375 }),
        React.createElement("g", { transform: "scale(.375)", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 3 },
            React.createElement("path", { d: "m44.834 25-11.083 11.083-5.8333-5.8333-8.75 8.75" }),
            React.createElement("path", { d: "m37.833 25h7v7" })))));
exports.default = SvgEmptyChart;
//# sourceMappingURL=EmptyChart.js.map